export const sectionsSelector = (sectionsObj) => {
  return Object.keys(sectionsObj)
    .map((sectionKey) => sectionsObj[sectionKey]);
};

export const sectionsIDSelector = (sectionsObj) => {
  return Object.keys(sectionsObj)
    .map((sectionKey) => sectionKey);
};
